var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"stats m-0"},[_c('b-col',[_c('div',{staticClass:"time float-right"},[_vm._v(" Current time: "),_c('span',{staticClass:"time-value"},[_vm._v(" "+_vm._s(_vm.time)+" ")]),_vm._v(" UTC ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }